export default __webpack_public_path__ + "static/media/img-3.6d683c0e.jpg";